import { Button } from '@nextui-org/react'

import { Bag } from '../../../components/icons/outline'
import { BagIcon as BagSolid } from '../../../components/icons/solid'
import { useCartStore } from '../../../libs/stores/useCartStore'

function MiniCartButton() {
  const { itemCount, openMiniCart } = useCartStore((state) => state)
  return (
    <Button isIconOnly onClick={openMiniCart} type="button" variant="light">
      {(!itemCount || itemCount === 0) && (
        <Bag className="block h-10 w-10 !max-w-none" />
      )}
      {itemCount > 0 && (
        <>
          <BagSolid className="block h-10 w-10 !max-w-none" />
          <span className="-ml-2 text-xs">{itemCount}</span>
        </>
      )}
    </Button>
  )
}

export default MiniCartButton
